import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCustomerDetails, getSecureAuthToken, setupSecureAuthTokenRenewal } from '../../auth/auth.actions';
import { getSSMCustomerData } from '../../views/ssm-homepage/ssm-homepage.actions';
import { startNewBusinessCase } from '../../views/business-case/business-case.actions';
import { getFFWDCustomerData } from '../../views/ffwd-homepage/ffwd-homepage.actions';
import { getNGMCustomerData } from '../../views/ngm-homepage/ngm-homepage.actions';
import { getAMSCustomerData } from '../../views/ams-homepage/ams-homepage.actions';
import { getAMCCustomerData } from '../../views/amc-homepage/amc-homepage.actions';
import { getAMPCustomerData } from '../../views/amp-homepage/amp-homepage.actions';
import { getSCTCustomerData } from '../../views/sct-homepage/sct-homepage.actions';
import DataBootStrapView from './data-bootstrap.presenter';
import {
  AUTH_API_SUCCESS_USER_INFO,
  APP_CONFIG,
  CIP_LOGOUT_URL,
  SESSION_TIMEOUT_MINUTES,
  CIP_LOGIN_URL,
  SESSION_TIMEOUT_RENEWAL,
  API_GENERAL_ERROR,
  API_COMPLETE_VANTAGE_ENDPOINT,
  API_COMPLETE_HOSTED_MIGRATION_ENDPOINT,
  API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_AME_CUSTOMER_DATA,
  API_COMPLETE_GET_AMP_CUSTOMER_DATA,
  SESSION_RENEWAL_START,
  SESSION_RENEWAL_COMPLETE,
  SESSION_RENEWAL_FAILED,
  SESSION_RENEWAL_POPUP_CLOSE,
  SECURE_AUTH_TOKEN_SUCCESS,
} from '../../app-constants';
import {
  setRedirectToLogoutAutomatically,
  setupSilentRenew,
  generateRandomString,
  closeSessionPopRenewalPopup,
} from '../../app-actions';
import { getVantage } from '../../views/vantage/vantage.actions';
import getHostedMigration from '../../views/hosted-migration/hosted-migration.actions';
import getBusinessPopMail from '../../views/business-pop-mail/business-pop-mail.actions';
import getAdaptiveMobilityExternal from '../../views/adaptive-mobility-external/adaptive-mobility-external.actions';


// Reducer
export const dataBootStrapReducer = (state = {
  hasError: false,
  loading: true,
  authentication: { isAuthenticated: false, cidn: '' },
  secureAuthAuthenticated: false,
  sessionRenewalInProgress: false,
  sessionRenewalComplete: false,
  sessionRenewalFailed: false,
}, action) => {
  switch (action.type) {
    case AUTH_API_SUCCESS_USER_INFO: {
      return { ...state, loading: false, authentication: { isAuthenticated: true } };
    }
    case API_GENERAL_ERROR: {
      return { ...state, hasError: true };
    }
    case SECURE_AUTH_TOKEN_SUCCESS: {
      return { ...state, loading: false, secureAuthAuthenticated: true };
    }
    case API_COMPLETE_VANTAGE_ENDPOINT: {
      return { ...state, loading: false, data: action.data };
    }
    case API_COMPLETE_HOSTED_MIGRATION_ENDPOINT: {
      return { ...state, loading: false, data: action.data };
    }
    case API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT: {
      return { ...state, loading: false, data: action.data };
    }
    case API_INITIATE_GET_AME_CUSTOMER_DATA: {
      return { ...state, loading: false, data: action.data };
    }
    case API_COMPLETE_GET_AMP_CUSTOMER_DATA: {
      return { ...state, loading: false, data: action.data };
    }
    case SESSION_RENEWAL_START: {
      return { ...state, sessionRenewalInProgress: true, sessionRenewalComplete: false, sessionRenewalFailed: false };
    }
    case SESSION_RENEWAL_COMPLETE: {
      return { ...state, sessionRenewalInProgress: false, sessionRenewalComplete: true };
    }
    case SESSION_RENEWAL_FAILED: {
      return { ...state, sessionRenewalInProgress: false, sessionRenewalFailed: true };
    }
    case SESSION_RENEWAL_POPUP_CLOSE: {
      return { ...state, sessionRenewalInProgress: false, sessionRenewalComplete: false, sessionRenewalFailed: false };
    }

    default:
      return state;
  }
};

// Map & Connect API_COMPLETE_HOSTED_MIGRATION_ENDPOINT
export const mapStateToProps = state => ({
  authentication: state.dataBootStrapReducer.authentication,
  secureAuthAuthenticated: state.dataBootStrapReducer.secureAuthAuthenticated,
  authByPass: APP_CONFIG.authByPass,
  cipLogoutUrl: CIP_LOGOUT_URL,
  cipLoginUrlForRenew: CIP_LOGIN_URL + generateRandomString(9),
  sessionTimeOutMinutes: SESSION_TIMEOUT_MINUTES,
  dataLoaded: !state.dataBootStrapReducer.loading,
  sessionRenewalMinutes: SESSION_TIMEOUT_RENEWAL,
  hasError: state.dataBootStrapReducer.hasError,
  sessionRenewalInProgress: state.dataBootStrapReducer.sessionRenewalInProgress,
  sessionRenewalComplete: state.dataBootStrapReducer.sessionRenewalComplete,
  sessionRenewalFailed: state.dataBootStrapReducer.sessionRenewalFailed,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getCustomerDetails,
    setRedirectToLogoutAutomatically,
    setupSilentRenew,
    getVantage,
    getSSMCustomerData,
    getHostedMigration,
    getBusinessPopMail,
    startNewBusinessCase,
    getFFWDCustomerData,
    getNGMCustomerData,
    getAMSCustomerData,
    getAMCCustomerData,
    getAMPCustomerData,
    getSCTCustomerData,
    getAdaptiveMobilityExternal,
    closeSessionPopRenewalPopup,
    getSecureAuthToken,
    setupSecureAuthTokenRenewal,
  }, dispatch),
});

const DataBootStrap = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataBootStrapView);

export default DataBootStrap;
